import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, ArrowRight } from "lucide-react";
import { motionOk } from "../lib/motionOk.js";
import { useLang } from "../i18n.jsx";

export default function CaseStudies() {
  const { content } = useLang();
  const { caseStudies, caseStudiesHead, csLabels } = content;
  return (
    <section id="kasus" className="relative px-6 py-20 overflow-hidden">
      <div className="pointer-events-none absolute -left-24 top-1/3 w-[440px] h-[440px] rounded-full bg-acid/[0.04] blur-3xl" />
      <div className="relative mx-auto max-w-5xl">
        <motion.div
          initial={motionOk ? { opacity: 0, y: 24 } : false}
          whileInView={motionOk ? { opacity: 1, y: 0 } : undefined}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl"
        >
          <p className="mb-4 text-[12px] uppercase tracking-[0.3em] text-acid">{caseStudiesHead.eyebrow}</p>
          <h2 className="font-display font-extrabold tracking-tight text-[clamp(1.8rem,4.2vw,3.2rem)] leading-[1.08]">
            {caseStudiesHead.titleA}
            <span className="block">{caseStudiesHead.titleB}</span>
          </h2>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {caseStudies.map((c, i) => (
            <motion.div
              key={c.role}
              initial={motionOk ? { opacity: 0, y: 30 } : false}
              whileInView={motionOk ? { opacity: 1, y: 0 } : undefined}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="flex flex-col rounded-3xl border border-paper/10 bg-ink2/60 p-8"
            >
              <div className="flex items-center gap-3">
                <span className="grid place-items-center w-11 h-11 rounded-2xl bg-acid/10 text-acid"><TrendingUp className="w-5 h-5" /></span>
                <h3 className="font-display text-lg font-bold tracking-tight text-paper">{c.role}</h3>
              </div>
              <div className="mt-6 space-y-5">
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-paper/55">{csLabels.challenge}</p>
                  <p className="mt-1 text-[15px] text-paper/70 leading-relaxed">{c.challenge}</p>
                </div>
                <div className="flex items-center gap-2 text-acid"><ArrowRight className="w-4 h-4" /><span className="text-xs uppercase tracking-[0.2em]">{csLabels.solution}</span></div>
                <div>
                  <p className="mt-1 text-[15px] text-paper/70 leading-relaxed">{c.solution}</p>
                </div>
                <div className="rounded-2xl border border-acid/30 bg-acid/10 px-5 py-4">
                  <p className="text-xs uppercase tracking-[0.2em] text-acid">{csLabels.result}</p>
                  <p className="mt-1 text-paper text-[15px] font-semibold">{c.result}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
